// ログアウトの確認モーダル（docs/AUTH.md の実装順序(7)）。
//
// 🔴 **ログアウトはこの端末のゲームデータを破棄する**。押した人が想像するのは
//    「ログイン状態が解ける」だけなので、**記録が消えることを先に言う**。
//    言わずに消すと「ログアウトしたら記録が消えた」という、後から説明しても納得されない事故になる。
//    ※ アカウントの記録はサーバーに残るので、入り直せば戻る。そこも同時に伝える。
import { t } from '@/platform/i18n';
import { logoutThisDevice } from '@/platform/net/account';
import { el, openOverlay } from './modalChrome';

/** 確認 → ログアウトまで面倒を見る。実行したら true（呼び出し側は再描画する）。 */
export function confirmLogout(): Promise<boolean> {
  return new Promise((resolve) => {
    const { overlay, panel, close } = openOverlay();

    const title = el('div', 'hs-modal-title', t('portal.logout.title'));
    const body = el('div', 'hs-modal-body');
    const list = document.createElement('ul');
    for (const text of [t('portal.logout.item1'), t('portal.logout.item2')]) {
      list.append(el('li', '', text));
    }
    body.append(el('div', '', t('portal.logout.body')), list);
    // 「戻ってくる方法がある」を必ず添える。無いと、押すのが怖くて出口として機能しない。
    body.append(el('div', 'hs-field-note', t('portal.logout.note')));

    const warn = el('div', 'hs-modal-warn', t('portal.logout.warn'));
    const row = el('div', 'hs-modal-row');
    const cancelBtn = el('button', 'hs-btn hs-btn-ghost', t('portal.logout.cancel'));
    const okBtn = el('button', 'hs-btn hs-btn-danger', t('portal.logout.submit'));
    row.append(cancelBtn, okBtn);
    panel.append(title, body, warn, row);

    const done = (v: boolean) => {
      close();
      resolve(v);
    };

    let busy = false;
    okBtn.addEventListener('click', () => {
      if (busy) return;
      busy = true;
      (okBtn as HTMLButtonElement).disabled = true;
      (cancelBtn as HTMLButtonElement).disabled = true;
      okBtn.textContent = t('portal.logout.working');
      // ⚠️ `logoutThisDevice` は失敗しない（通信が落ちてもローカルは消す）。
      //    出口を塞がないための約束なので、ここに失敗の分岐は要らない。
      void logoutThisDevice().then(() => done(true));
    });
    cancelBtn.addEventListener('click', () => done(false));
    overlay.addEventListener('mousedown', (e) => {
      if (e.target === overlay && !busy) done(false);
    });
  });
}
